export default __webpack_public_path__ + "assets/images/select-events-7a902380d56373042c2683b174c00552.png";